"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGpbCheckoutEvents = void 0;
/**
 * A builder for GpbCheckoutEvents
 *
 * @param data - The event data
 * @return The formatted event data for GpbCheckoutEventsEvent
 */
function createGpbCheckoutEvents(data) {
    return {
        name: 'GpbCheckoutEvents',
        environments: ['device', 'browser'],
        data: data,
    };
}
exports.createGpbCheckoutEvents = createGpbCheckoutEvents;
//# sourceMappingURL=createGpbCheckoutEvents.js.map